import { Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CreateContactForm } from '../../../../sic-lib/types/Contact';
import { ContactAddress, FormFieldCreateContact } from '../../../../sic-lib/types/ContactField';

const useStyles = makeStyles()((theme: Theme) => ({
    inputWrapper: {},
}));

interface Props {
    field: FormFieldCreateContact<ContactAddress>;
    size?: 'medium' | 'small';
    onChangeHandler: (key: keyof CreateContactForm, field: FormFieldCreateContact) => void;
}

export default function ContactFormFastFieldAddress({
    field,
    size = 'medium',
    onChangeHandler,
}: Props) {
    const { classes } = useStyles();

    const [state, setState] = React.useState<ContactAddress>(field.value);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const addressField = event.target.name as keyof ContactAddress;

        setState({
            ...state,
            ...{
                [addressField]: event.target.value,
            },
        });
    };

    const handleBlur = () => {
        onChangeHandler('address', {
            ...field,
            ...{
                value: state,
            },
        });
    };

    return (
        <>
            <Grid item xs={6}>
                <TextField
                    id={`${field.label}_street_${field.fieldId}`}
                    name="street"
                    label="Street"
                    value={state.street}
                    size={size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    id={`${field.label}_city_${field.fieldId}`}
                    name="city"
                    label="City"
                    value={state.city}
                    size={size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    id={`${field.label}_province_${field.fieldId}`}
                    name="province"
                    label="State/Province"
                    value={state.province}
                    size={size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    id={`${field.label}_country_${field.fieldId}`}
                    name="country"
                    label="Country"
                    value={state.country}
                    size={size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    id={`${field.label}_postal_${field.fieldId}`}
                    name="postalCode"
                    label="Zip/Postal Code"
                    value={state.postalCode}
                    size={size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                />
            </Grid>
        </>
    );
}
